import { createSlice } from '@reduxjs/toolkit';
import { IAction } from 'src/types/actions';
import { IAiModel, StringKeys } from 'src/types/base';
import { CHAT_PRE_CREATION_ID } from 'src/utils/constants';

export type AssistantType = {
  name?: string;
  description?: string;
  personaId?: number;
  instructions?: string;
  conversationStarter?: string[];
  aiModel?: IAiModel;
  fileList?: StringKeys[];
  assistantActions?: IAction[];
  isWebSearch?: boolean;
  assistantIcon?: string;
  permission?: StringKeys;
  worldKnowledge?: boolean;
  allEnterpriseKnowledge?: boolean;
  id?: number;
  settings?: StringKeys;
  [z: string]: any;
};

export type AssistantContextType = {
  isPreview: boolean;
  isAssistant: boolean;
  isStartChat: boolean;
  isCreatingAssistant: boolean;
  isUpdated: boolean;
  isPreviewReset: boolean;
  isAssistantDeleted: boolean;
};
type InitiateAssistant = {
  assistantObj: AssistantType;
  assistantContext: AssistantContextType;
  starterQuestion: string;
  isAssistantEditFromChat: boolean;
};

export const initialAssistantState = {
  name: '',
  description: '',
  personaId: null,
  instructions: '',
  conversationStarter: [],
  aiModel: null,
  fileList: [],
  assistantActions: [],
  isWebSearch: false,
  assistantIcon: '',
  permission: {},
  worldKnowledge: false,
  allEnterpriseKnowledge: false,
  id: null,
  settings: {}
};

export const initialAssistantContextState = {
  isPreview: false,
  isAssistant: false,
  isStartChat: false,
  isCreatingAssistant: false,
  chatId: CHAT_PRE_CREATION_ID,
  isUpdated: false,
  isPreviewReset: false,
  isAssistantDeleted: false
};

const initialState: InitiateAssistant = {
  assistantObj: initialAssistantState,
  assistantContext: initialAssistantContextState,
  starterQuestion: '',
  isAssistantEditFromChat: false
};

const slice = createSlice({
  name: 'assistant',
  initialState,
  reducers: {
    updateInitiateAssistantState: (
      state,
      action: { payload: AssistantType }
    ) => {
      const { payload } = action;
      Object.assign(state.assistantObj, payload);
    },
    updateAssistantContext: (
      state,
      action: { payload: AssistantContextType }
    ) => {
      const { payload } = action;
      Object.assign(state.assistantContext, payload);
    },
    updateStarterQuestion: (state, action: { payload: string }) => {
      const { payload } = action;
      state.starterQuestion = payload;
    },
    updateIsAssistantEditFromChat: (state, action) => {
      const { payload } = action;
      state.isAssistantEditFromChat = payload;
    },
    updateIsPreviewToggled: (state, action) => {
      const { payload } = action;
      state.assistantContext.isPreviewReset = payload;
    }
  }
});

export const reducer = slice.reducer;
export const {
  updateInitiateAssistantState,
  updateAssistantContext,
  updateStarterQuestion,
  updateIsAssistantEditFromChat,
  updateIsPreviewToggled
} = slice.actions;

export default slice;
